import { useEffect, useState } from 'react'

import Api from 'services/api'
import { PaywallAcct } from 'types/PaywallAcct'
import { PaywallPlanChange } from 'types/PaywallPlanChange'

const useActivePremiumAccount = (dealerId) => {
  const [activeAccount, setActiveAccount] = useState<PaywallAcct>()
  const [isActiveAccountLoaded, setIsActiveAccountLoaded] = useState(false)
  const [planChange, setPlanChange] = useState<PaywallPlanChange>()
  const [isPaywallPlanChangeLoaded, setPaywallPlanChangeLoaded] = useState(false)

  useEffect(() => {
    if (dealerId) {
      Api.Paywall.getActiveAcct(dealerId, 'premium')
        .then(res => {
          setActiveAccount(res)
        })
        .catch(() => {
          setIsActiveAccountLoaded(true)
        })
        .finally(() => setIsActiveAccountLoaded(true))

      Api.Paywall.getAcctPlanChange(dealerId, 'premium')
        .then(res => {
          setPlanChange(res)
        })
        .catch(() => {
          setPaywallPlanChangeLoaded(true)
        })
        .finally(() => setPaywallPlanChangeLoaded(true))
    }
  }, [dealerId])

  return { activeAccount, isActiveAccountLoaded, planChange, isPaywallPlanChangeLoaded }
}

export default useActivePremiumAccount
